// external js: isotope.pkgd.js (vanilla API — no jQuery required)

window.addEventListener('load', function () {
  var grid = document.querySelector('.product-boards');
  if (!grid || typeof Isotope === 'undefined') return;

  var iso = new Isotope(grid, {
    itemSelector: '.product-board',
    transitionDuration: 0
  });

  var filterBar = document.getElementById('product-board-filter');
  if (!filterBar) return;

  filterBar.addEventListener('click', function (event) {
    var button = event.target.closest('button');
    if (!button || !filterBar.contains(button)) return;

    var filterValue = button.getAttribute('data-filter');

    filterBar.querySelectorAll('button').forEach(function (b) {
      b.classList.remove('active');
    });
    button.classList.add('active');

    var boards = document.querySelectorAll('.product-board');
    boards.forEach(function (b) {
      b.classList.remove('in-viewport');
    });

    iso.arrange({ filter: filterValue });

    boards.forEach(function (b) {
      b.classList.add('in-viewport');
    });
  });
});
